import React from "react";
import {Navigate, useRoutes} from "react-router";
import AppManager from "../apps/manager/appManager";
import AnalyticsPage from "../apps/manager/pages/analytics/AnalyticsPage";
import {routesChat} from "./routesChat";
import FeedsPage from "../features/chat/feeds/FeedsPage";
import FeedItems from "../features/chat/feeds/components/FeedItems";
import ReadbookPage from "../apps/policymaker/pages/readbooks/ReadbookPage";
import KnowledgeBasePage from "../features/knowledgeBase/KnowledgeBasePage";
import EntitiesList from "../features/knowledgeBase/EntitiesList";
import EntityDetailPage from "../features/knowledgeBase/EntityDetailPage";
import WhiteboardsListPage from "../features/whiteboards/WhiteboardsListPage";
import WhiteboardPage from "../features/whiteboards/WhiteboardPage";
import LegacyWhiteboardRedirect from "./LegacyWhiteboardRedirect";
import WorkflowPage from "../features/workflow/WorkflowPage";
import HelpPage from "../features/help/HelpPage";

const routesManager = [
    ...routesChat,
    {
        path: "/",
        element: <AppManager/>,
        children: [
            {index: true, element: <Navigate to="analytics" replace/>},
            {path: "analytics", element: <AnalyticsPage/>,},
            {path: "workflow", element: <WorkflowPage/>,},
            {path: "billing", element: <Navigate to="/analytics" replace/>,},
            {path: "charts", element: <WhiteboardsListPage/>},
            {
                path: "feed",
                element: <FeedsPage/>,
                children: [
                    {
                        path: ":feedId", element: <FeedItems/>,
                        children: [
                            {path: ":sourceSegmentId", element: <ReadbookPage/>},
                        ],
                    },],
            },
            {path: "help", element: <HelpPage/>},
            {
                path: "kb",
                element: <KnowledgeBasePage/>,
                children: [
                    {index: true, element: <EntitiesList/>},
                    {path: ":entityId", element: <EntityDetailPage/>},
                ],
            },
        ],
    },
    {
        path: "/charts/:whiteboardId",
        element: <WhiteboardPage/>,
    },
    {path: "/whiteboards", element: <Navigate to="/charts" replace/>},
    {path: "/whiteboards/*", element: <LegacyWhiteboardRedirect/>},
    {path: "*", element: <Navigate to="/analytics" replace/>},
];

export function RoutesManager() {
    return useRoutes(routesManager);
}